// Mock data for Elenor Consulting website

export const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Staffing', path: '/staffing' },
  { name: 'Services', path: '/services' },
  { name: 'Industries', path: '/industries' },
  { name: 'Training', path: '/training' },
  { name: 'Contact', path: '/contact' }
];

export const heroData = {
  title: 'Consulting & Staffing Services',
  subtitle: 'Delivering innovative solutions to tackle the biggest Services challenges',
  description: 'Countries around the world are facing common challenges and opportunities impacting the Staffing of their citizens and their Consulting Services',
  image: 'https://images.pexels.com/photos/4098252/pexels-photo-4098252.jpeg'
};

export const aboutData = {
  title: 'Data Lineage Consulting - Professional Advice',
  description1: 'We have committed to provide personalized, conscientious, and comprehensive services to our clientele. Service that will not only enable you and your Staffing Solutions organization to realize sustainable success, but to arrive at that point having also developed confidence and trust in our ability to assist you in future endeavors.',
  description2: 'Our firm\'s team of Staffing consultants carry a variety of specialty credentials from all corners of the field. However, they do share a common trait in that they all have years of hands on experience in their areas of expertise.',
  image: 'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg'
};

export const staffingServices = [
  {
    id: 1,
    title: 'Contract/Temporary Hire',
    description: 'When you need temp staffing services—for one project, one season or one year—talk to us first. We\'ve got the largest network of pre-qualified candidates anywhere.',
    image: 'https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg'
  },
  {
    id: 2,
    title: 'Direct/Permanent Hire',
    description: 'When a client has a long-term need, direct hire is ideal. Direct hire positions are permanent, usually full-time positions with benefits. A staffing agency helps match qualified candidates with employers.',
    image: 'https://images.pexels.com/photos/590016/pexels-photo-590016.jpeg'
  },
  {
    id: 3,
    title: 'Contingent Workforce',
    description: 'In the current economy, contingent workers are an integral and growing part of the workforce. Whether freelancers, consultants or contract workers, we help you manage your contingent workforce effectively.',
    image: 'https://images.pexels.com/photos/8124246/pexels-photo-8124246.jpeg'
  }
];

export const services = [
  {
    id: 1,
    title: 'Application Development',
    description: 'Beyond website development we also specialise in developing responsive web apps and mobile apps.',
    icon: 'Code'
  },
  {
    id: 2,
    title: 'Data Management',
    description: 'As more and more organizations jump on the Managed IT Services bandwagon, it\'s becoming easier to see that the benefits of managed services are many.',
    icon: 'Database'
  },
  {
    id: 3,
    title: 'Data Warehousing',
    description: 'Data warehousing is a methodology that is used for fetching and controlling data from different sources to give sensible organization vision.',
    icon: 'Warehouse'
  }
];

export const industries = [
  {
    id: 'banking',
    name: 'Banking & Finance',
    title: 'Financial Planning Services',
    description1: 'We staff a variety of positions that serve the innovative technology adopted by the Account & Financial Services industry. We deal in fields such as big data, design, and a study of the user experience to provide clients\' customers with the convenience and efficiency guaranteed by cutting-edge digital technology.',
    description2: 'Financial planning firms help businesses plan for the future. Business owners often consult financial planners to determine the best steps to take in order to reach their monetary goals. The financial planning process involves setting objectives, evaluating resources, and making plans to work towards those objectives.',
    image: 'https://images.pexels.com/photos/7681081/pexels-photo-7681081.jpeg'
  },
  {
    id: 'healthcare',
    name: 'Healthcare',
    title: 'Health organizations are implementing innovative digital health strategies',
    description1: 'Healthcare enterprises including providers and payers are constantly striving to achieve three major objectives: Improve patient care experience, optimize health outcomes and reduce healthcare costs through healthcare consulting.',
    description2: 'We are always at the cutting edge of the quest to continuously improve on best practices in healthcare IT consulting services. Our enterprise medical service experts have helped our customers to maximize their Return on Investment.',
    image: 'https://images.pexels.com/photos/35165115/pexels-photo-35165115.jpeg'
  },
  {
    id: 'insurance',
    name: 'Insurance',
    title: 'Insurance Sector',
    description1: 'Data Lineage Consulting Insurance Industry Services can help you improve profitability while balancing the demands of regulatory change and shifting customer expectations. Our multidisciplinary approach brings together specialists in actuarial, risk management, strategy, operations, technology, tax, and audit.',
    description2: 'We provide comprehensive insurance industry solutions that help you navigate the complex regulatory landscape while maintaining competitive advantage.',
    image: 'https://images.pexels.com/photos/3184438/pexels-photo-3184438.jpeg'
  }
];

export const statistics = [
  { value: 10, label: 'Satisfied Customers' },
  { value: 5, label: 'Years of Excellence' },
  { value: 24, label: 'Hours Support' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Jack Wilson',
    role: 'CEO, Tech Corp',
    comment: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.',
    image: 'https://images.pexels.com/photos/4098252/pexels-photo-4098252.jpeg'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    role: 'Director, Healthcare Plus',
    comment: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.',
    image: 'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg'
  },
  {
    id: 3,
    name: 'Michael Chen',
    role: 'Manager, Finance Solutions',
    comment: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.',
    image: 'https://images.pexels.com/photos/8124246/pexels-photo-8124246.jpeg'
  }
];

export const whyUsPoints = [
  {
    number: '01',
    title: 'Battle-Tested',
    description: 'Data Lineage Consulting brings the best from both software worlds to your industry. From one side, you get our 10-year expertise in building wide-ranging custom software.'
  },
  {
    number: '02',
    title: 'Our Vision',
    description: 'We intend to provide our customers with improved consulting, training, and staffing services. Whether it is a consumer-oriented app or a transformative enterprise-class solution, the company leads the process from ideation and concept to delivery.'
  },
  {
    number: '03',
    title: 'Our Mission',
    description: 'We believe in strong relationship with customer by having customer is first philosophy. Our mission is to help enterprises accelerate adoption of new technologies, untangle complex issues that always emerge during digital evolution.'
  },
  {
    number: '04',
    title: 'Highest Quality',
    description: 'Give everyone responsibility, corresponding authority, and make sure everyone shares the goals and values.'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'Healthcare Consulting: What It Is & How to Succeed in It',
    excerpt: 'It\'s no secret that the healthcare industry is complex. With hundreds of laws, policies, and regulations, the wide range of potential professions and jobs, and daily developments.',
    image: 'https://images.pexels.com/photos/4421494/pexels-photo-4421494.jpeg',
    date: '30 Jul',
    category: 'Healthcare'
  },
  {
    id: 2,
    title: 'How data will make or break healthcare AI',
    excerpt: 'Learn how data will make or break healthcare AI in this comprehensive analysis. Understanding the critical role of data quality in healthcare artificial intelligence.',
    image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b',
    date: '29 Jul',
    category: 'Technology'
  },
  {
    id: 3,
    title: 'Virtual health reaches the point of no return',
    excerpt: 'Virtual health has skyrocketed amid the pandemic. Lack of integration may hinder its sustainability. The wide range of potential professions and jobs.',
    image: 'https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg',
    date: '28 Jul',
    category: 'Digital Health'
  }
];

export const contactInfo = {
  address: {
    company: 'Data Lineage Consulting Limited',
    street: 'Regus House, Malthouse Avenue',
    street2: 'Cardiff Gate Business Park',
    city: 'Cardiff, Mid Glamorgan',
    postcode: 'CF23 8RU',
    country: 'United Kingdom'
  },
  phone: '+44 7776 597479',
  email: 'info@datalineage.co.uk',
  socials: [
    { name: 'Facebook', url: '#', icon: 'Facebook' },
    { name: 'Twitter', url: '#', icon: 'Twitter' },
    { name: 'LinkedIn', url: '#', icon: 'Linkedin' },
    { name: 'Instagram', url: '#', icon: 'Instagram' }
  ]
};
